module.exports = __webpack_public_path__ + "static/Dizel Viljuškari-2732c07bd8e8f46fc089dfc37c5ab6b9.pdf";